import React from 'react';
import { Box } from '@mui/material';
import CardHeader from '../shared/CardHeader';
import CardContainer from '../shared/CardContainer';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { formatNumberDE } from '../../../../../../shared/utils/formatNumber';

const MonthlyTable = ({ data = {} }) => {
  const columns = React.useMemo(() => {
    if (!data.columns) return [];
    return data.columns.map((col) => {
      if (col.field === 'rowName') return col;
      return { ...col, valueFormatter: formatNumberDE };
    });
  }, [data.columns]);

  return (
    <CardContainer>
      <CardHeader title='Monthly Numbers' />
      <Box sx={{ height: '335px', width: '100%' }}>
        <DataGridPro rows={data.rows} columns={columns} />
      </Box>
    </CardContainer>
  );
};

export default MonthlyTable;
